import { render, staticRenderFns } from "./EMWidgetMessage.vue?vue&type=template&id=2862975a&scoped=true&"
import script from "./EMWidgetMessage.vue?vue&type=script&lang=js&"
export * from "./EMWidgetMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862975a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
